import React from 'react';
import PropTypes from 'prop-types';
import CwImage from '../cwimage/CwImage';
import CwFlexbox from '../cwflexbox/CwFlexbox';
import css from './CwNotification.scss';
import cx from 'classnames';
import IconPath from 'src/utils/IconPath';

export const CwNotificationStatus = {
  ERROR: 'Error',
  INFORMATIONAL: 'Informational',
  WARNING: 'Warning',
  SUCCESSFUL: 'Successful'
};

const CwNotification = (props) => {

  const wrapClass = cx({
    [css.wrap]: true,
    [props.className]: props.className,
    [css.error]: props.status === CwNotificationStatus.ERROR,
    [css.informational]: props.status === CwNotificationStatus.INFORMATIONAL,
    [css.warning]: props.status === CwNotificationStatus.WARNING,
    [css.successful]: props.status === CwNotificationStatus.SUCCESSFUL,
  });

  return (
    <div onFocus={props.onFocus}
      onBlur={props.onBlur}
      data-cwid={props.cwId}
      style={props.style}
      className={wrapClass}>
      <CwFlexbox verticalAlign>
        <CwImage src={props.statusIcon} className={css.icon} />
        <div className={css.text}>{props.message}</div>
        <CwImage src={props.closeIcon} className={css.icon} onClick={props.onClose} />
      </CwFlexbox>
      {props.children ? <div className={css.children}>{props.children}</div> : null}
    </div>
  );
};

CwNotification.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  status: PropTypes.oneOf(
    [CwNotificationStatus.ERROR, CwNotificationStatus.INFORMATIONAL, CwNotificationStatus.WARNING, CwNotificationStatus.SUCCESSFUL]
  ).isRequired,
  statusIcon: PropTypes.string.isRequired,
  closeIcon: PropTypes.string,
  message: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

CwNotification.defaultProps = {
  closeIcon: IconPath.get('Action_Close')
};

export default CwNotification;


// WEBPACK FOOTER //
// ./src/components/cwnotification/CwNotification.jsx